module.exports = __webpack_public_path__ + "img/877B70_34302B_CBB3A4_524C44-256px.b99d2be8.png";